import {
  Sword,
  Compass,
  GraduationCap,
  Film,
  Mountain,
  PartyPopper,
  Puzzle,
  Crown,
  UserCircle,
  Crosshair,
  ShoppingBag,
  Activity,
  Users,
  Trophy,
  Brain,
  Tent,
  Wrench,
  Hammer,
  Ghost,
  Building2,
  Shield,
  Laugh,
  Castle,
  Rocket,
  Anchor,
  SwordIcon,
  Palmtree,
  Gamepad2,
} from "lucide-react";

interface GenreIconProps {
  genre: string;
  className?: string;
  size?: number;
}

export function GenreIcon({
  genre,
  className = "size-5 text-primary",
  size = 16,
}: GenreIconProps) {
  const normalizedGenre = genre?.toLowerCase() || "";

  switch (true) {
    case normalizedGenre.includes("action"):
      return <Sword className={className} size={size} />;

    case normalizedGenre.includes("adventure"):
      return <Compass className={className} size={size} />;

    case normalizedGenre.includes("education"):
    case normalizedGenre.includes("learn"):
      return <GraduationCap className={className} size={size} />;

    case normalizedGenre.includes("entertainment"):
      return <Film className={className} size={size} />;

    case normalizedGenre.includes("obby"):
    case normalizedGenre.includes("platformer"):
      return <Mountain className={className} size={size} />;

    case normalizedGenre.includes("party"):
    case normalizedGenre.includes("casual"):
      return <PartyPopper className={className} size={size} />;

    case normalizedGenre.includes("puzzle"):
      return <Puzzle className={className} size={size} />;

    case normalizedGenre.includes("rpg"):
      return <Crown className={className} size={size} />;

    case normalizedGenre.includes("roleplay"):
    case normalizedGenre.includes("avatar"):
    case normalizedGenre.includes("sim"):
      return <UserCircle className={className} size={size} />;

    case normalizedGenre.includes("shooter"):
    case normalizedGenre.includes("fps"):
      return <Crosshair className={className} size={size} />;

    case normalizedGenre.includes("shop"):
      return <ShoppingBag className={className} size={size} />;

    case normalizedGenre.includes("simulation"):
      return <Activity className={className} size={size} />;

    case normalizedGenre.includes("social"):
      return <Users className={className} size={size} />;

    case normalizedGenre.includes("sports"):
    case normalizedGenre.includes("racing"):
      return <Trophy className={className} size={size} />;

    case normalizedGenre.includes("strategy"):
      return <Brain className={className} size={size} />;

    case normalizedGenre.includes("survival"):
      return <Tent className={className} size={size} />;

    case normalizedGenre.includes("utility"):
    case normalizedGenre.includes("other"):
      return <Wrench className={className} size={size} />;

    case normalizedGenre.includes("building"):
      return <Hammer className={className} size={size} />;

    case normalizedGenre.includes("horror"):
      return <Ghost className={className} size={size} />;

    case normalizedGenre.includes("town"):
    case normalizedGenre.includes("city"):
      return <Building2 className={className} size={size} />;

    case normalizedGenre.includes("military"):
      return <Shield className={className} size={size} />;

    case normalizedGenre.includes("comedy"):
      return <Laugh className={className} size={size} />;

    case normalizedGenre.includes("medieval"):
      return <Castle className={className} size={size} />;

    case normalizedGenre.includes("sci-fi"):
    case normalizedGenre.includes("scifi"):
      return <Rocket className={className} size={size} />;

    case normalizedGenre.includes("naval"):
      return <Anchor className={className} size={size} />;

    case normalizedGenre.includes("fighting"):
      return <SwordIcon className={className} size={size} />;

    case normalizedGenre.includes("western"):
      return <Palmtree className={className} size={size} />;

    default:
      return <Gamepad2 className={className} size={size} />;
  }
}
